<template>
    <v-menu transition="slide-x-transition" content-class="noshadow" bottom right>
        <template v-slot:activator="{ on }">
            <v-btn
                :text="deleteButton.type === 'icon'"
                :icon="deleteButton.type === 'icon'"
                :disabled="deleteButton.disabled"
                :outlined="deleteButton.outline"
                :color="deleteButton.color"
                v-on="on"
            >
                <v-icon
                    :color="deleteButton.iconColor ? deleteButton.iconColor : 'error'"
                    size="20px"
                    v-if="deleteButton.type === 'icon'"
                >delete</v-icon>
                <span v-if="deleteButton.type === 'text'">{{ deleteButton.value }}</span>
            </v-btn>
        </template>

        <v-layout row wrap block block--compact>
            <v-flex xs12>
                <h4 class="mb-2">{{$t('components.lib.deleteDialog.itemQuestion')}} {{ itemName }}?</h4>
            </v-flex>
            <v-flex xs6>
                <v-btn color="success" @click="deleteEntry">{{$t('components.lib.deleteDialog.submit')}}</v-btn>
            </v-flex>
            <v-flex xs6 text-right>
                <v-btn color="error" text>{{$t('components.lib.deleteDialog.cancel')}}</v-btn>
            </v-flex>
        </v-layout>
    </v-menu>
</template>

<script>
export default {
    name: "DeleteDialog",
    props: {
        deleteButton: {
            type: Object,
            default() {
                return {
                    type: "text", // icon
                    value: "Delete", // icon value
                    color: "primary",
                    iconColor: "error",
                    disabled: false,
                    outlined: false
                };
            }
        },
        itemName: {
            type: String
        }
    },
    methods: {
        deleteEntry(item) {
            this.$emit("deleteEntry", item);
        }
    }
};
</script>
